<template>
  <transition name="fade">
    <div v-show="visible" class="back-to-top" @click="scrollToTop" :title="isDark ? '回到顶部' : '回到顶部'">
      <i class="el-icon-top"></i>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',
  data() {
    return {
      visible: false
    }
  },
  computed: {
    isDark() {
      return this.$store.getters.isDark
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.visible = window.pageYOffset > 300
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.back-to-top {
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--blog-accent-subtle);
  border: 1px solid var(--blog-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--blog-accent);
  font-size: 20px;
  transition: all 0.3s;
  z-index: 999;
  box-shadow: 0 2px 12px var(--blog-accent-glow);
}
.back-to-top:hover {
  background: var(--blog-accent);
  color: var(--blog-text-inverse);
  border-color: var(--blog-accent);
  box-shadow: 0 4px 20px var(--blog-accent-glow);
  transform: translateY(-2px);
}
.back-to-top i {
  font-weight: bold;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
@media (max-width: 768px) {
  .back-to-top {
    bottom: 20px;
    right: 16px;
    width: 38px;
    height: 38px;
    font-size: 18px;
  }
}
</style>

<!-- 浅色主题下由 global.css 覆盖 -->
